import { Component, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StorageHelper } from '@app/core/aws/storage.helper';
import AuthenticationFacade from '@app/core/facades/authentication.facade';
import StudentFacade from '@app/core/facades/student.facade';
import { MainHeaderComponent as CoachBotMainHeaderComponent } from '@app/shared/components/main-header/main-header.component';
import { ImageUploaderService } from '@app/shared/services/image-uploader.service';
import { ExtensionCommunicationService } from 'dashboard/modules/extension/services';

@Component({
  selector: 'dashboard-main-header',
  styleUrls: ['../../../../../../alpha-coach-bot/src/app/shared/components/main-header/main-header.component.scss'],
  templateUrl: './main-header.component.html',
})
export class MainHeaderComponent extends CoachBotMainHeaderComponent {
  constructor(
    protected readonly _auth: AuthenticationFacade,
    protected readonly _dialog: MatDialog,
    protected readonly _imageUploaderService: ImageUploaderService,
    private readonly _ngZone: NgZone,
    protected readonly _router: Router,
    protected readonly _storage: StorageHelper,
    protected readonly _student: StudentFacade,
    private readonly _extensionCommunicationService: ExtensionCommunicationService
  ) {
    super(_auth, _dialog, _imageUploaderService, _storage, _student);
  }

  onLogout(): void {
    this._auth.logout(() => {
      this._extensionCommunicationService.sendDashboardLogout();
    });
  }

  onOpenProfileSettings(): void {
    this._ngZone.run(() => {
      this._router.navigateByUrl('/profile/settings');
    });
  }
}
